export default [
  {
    path: 'exam-program-presentations',
    name: 'exam-program-presentations-front',
    component: () => import('@/views/pages/front/exam-program-presentation/Index.vue'),
    meta: {
      pageTitle: 'Imtihon dasturlari va taqdimotlar',
    },
  },
]
